import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-obs-social-leads',
  templateUrl: './obs-social-leads.component.html',
  styleUrls: ['./obs-social-leads.component.css'],
})
export class ObsSocialLeadsComponent implements OnInit {
  loading = false;
  searchText = '';
  leadsList: any[] = [];
  filteredLeads: any[] = [];
  url = 'socialLeads';

  // Summary KPIs
  totalLeads = 0;
  validLeads = 0;
  invalidLeads = 0;
  bookedLeads = 0;
  validLeadRate = 0;
  bookingRate = 0;
  avgResponseTimeMs = 0;

  modalTitle: string = '';
  modalContent: string | null = null;

  resumenCards = [
    {
      label: '',
      value: '',
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '',
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '',
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '',
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '',
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '',
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '',
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '',
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;

    const summaryReq = this.dataService.getData(this.url + '/summary');
    const leadsReq = this.dataService.getData(this.url + '?limit=50');

    forkJoin([summaryReq, leadsReq]).subscribe(
      ([summaryRes, leadsRes]: [any, any]) => {
        if (summaryRes && summaryRes.rst && summaryRes.data) {
          const s = summaryRes.data;
          this.totalLeads = s.total || 0;
          this.validLeads = s.validLeads || 0;
          this.invalidLeads = s.invalidLeads || 0;
          this.bookedLeads = s.bookedLeads || 0;
          this.validLeadRate = s.validLeadRate || 0;
          this.bookingRate = s.bookingRate || 0;
          this.avgResponseTimeMs = s.avgResponseTimeMs || 0;
        } else {
          this.messageService.add('Error loading summary', 'secondary');
        }

        if (leadsRes && leadsRes.rst && leadsRes.data) {
          this.leadsList = leadsRes.data;
          this.filteredLeads = [...this.leadsList];
        } else {
          this.messageService.add('Error loading leads', 'secondary');
        }

        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add('Error fetching leads data', 'danger');
        console.error(error);
      },
    );
  }

  applyFilter(event: any) {
    const text = event.target.value.trim().toLowerCase();
    if (!text) {
      this.filteredLeads = [...this.leadsList];
    } else {
      this.filteredLeads = this.leadsList.filter(
        (l) =>
          (l.source_platform &&
            l.source_platform.toLowerCase().includes(text)) ||
          (l.entry_point && l.entry_point.toLowerCase().includes(text)) ||
          (l.intent_classification &&
            l.intent_classification.toLowerCase().includes(text)) ||
          (l.normalized_message &&
            l.normalized_message.toLowerCase().includes(text)) ||
          (l.invalid_reason && l.invalid_reason.toLowerCase().includes(text)),
      );
    }
  }

  formatPercent(val: number): string {
    return (val * 100).toFixed(1) + '%';
  }

  getPlatformIcon(platform: string): string {
    switch (platform) {
      case 'instagram':
        return 'fab fa-instagram text-danger';
      case 'facebook':
        return 'fab fa-facebook text-primary';
      case 'linkedin':
        return 'fab fa-linkedin text-info';
      case 'whatsapp':
        return 'fab fa-whatsapp text-success';
      default:
        return 'fas fa-globe text-secondary';
    }
  }

  getSlaTime(lead: any): string {
    if (!lead.first_response_at) return 'Pending';
    const created = new Date(lead.createdAt).getTime();
    const responded = new Date(lead.first_response_at).getTime();
    const diffMins = Math.round((responded - created) / 60000);
    return diffMins + ' min';
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
